import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import api from "api/axios";

// Affiche les cases à cocher des documents d'un participant, avec accès au fichier uploadé.
// props:
//  - documents: [{ type_document_id, libelle, obligatoire, fourni, fichier }]
//  - onToggle: (type_document_id, fourni) => void
//  - readOnly: bool (optionnel)
//  - participantId: id du participant (nécessaire pour accéder aux fichiers)

async function recupererBlob(participantId, typeDocId) {
  const res = await api.get(
    `/oumrah/participants/${participantId}/documents/${typeDocId}/fichier`,
    { responseType: "blob" }
  );
  // Récupère le nom de fichier lisible depuis l'en-tête Content-Disposition
  const disposition = res.headers["content-disposition"] || "";
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match ? decodeURIComponent(match[1]) : "document";
  return { blob: res.data, filename };
}

async function voirDocument(participantId, typeDocId) {
  try {
    const { blob } = await recupererBlob(participantId, typeDocId);
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  } catch (err) {
    alert("Impossible d'ouvrir le document");
  }
}

async function telechargerDocument(participantId, typeDocId) {
  try {
    const { blob, filename } = await recupererBlob(participantId, typeDocId);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    alert("Impossible de télécharger le document");
  }
}

function DocumentsParticipant({ documents, onToggle, readOnly, participantId }) {
  if (!documents || documents.length === 0) {
    return (
      <MDTypography variant="caption" color="text" sx={{ fontStyle: "italic", pl: 2 }}>
        Aucun document à suivre.
      </MDTypography>
    );
  }
  return (
    <MDBox display="flex" flexWrap="wrap" gap={1} pl={2} mt={0.5}>
      {documents.map((d) => (
        <MDBox
          key={d.type_document_id}
          display="flex"
          alignItems="center"
          sx={{
            border: "1px solid",
            borderColor: d.fourni ? "#1D9E75" : (d.obligatoire ? "#e67e22" : "#e0e0e0"),
            borderRadius: "6px",
            px: 1,
            bgcolor: d.fourni ? "#f0faf5" : "transparent",
          }}
        >
          <Checkbox
            checked={!!d.fourni}
            disabled={readOnly}
            onChange={(e) => onToggle(d.type_document_id, e.target.checked)}
            size="small"
            sx={{ p: 0.5 }}
          />
          <MDTypography variant="caption" sx={{ fontWeight: d.obligatoire ? "bold" : "regular" }}>
            {d.libelle}
            {d.obligatoire && <span style={{ color: "#e67e22" }}> *</span>}
          </MDTypography>
          {d.fichier && participantId && (
            <>
              <Tooltip title="Voir le document">
                <IconButton size="small" onClick={() => voirDocument(participantId, d.type_document_id)} sx={{ p: 0.4, ml: 0.25 }}>
                  <Icon fontSize="small" sx={{ fontSize: "1rem !important", color: "#378ADD" }}>visibility</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title="Télécharger">
                <IconButton size="small" onClick={() => telechargerDocument(participantId, d.type_document_id)} sx={{ p: 0.4 }}>
                  <Icon fontSize="small" sx={{ fontSize: "1rem !important", color: "#378ADD" }}>download</Icon>
                </IconButton>
              </Tooltip>
            </>
          )}
        </MDBox>
      ))}
    </MDBox>
  );
}
export default DocumentsParticipant;
